import { Component, OnInit,Input } from '@angular/core';
import { CoreService } from 'src/app/service/core.service';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-mesurment-template',
  templateUrl: './mesurment-template.component.html',
  styleUrls: ['./mesurment-template.component.css']
})
export class MesurmentTemplateComponent implements OnInit {
  
   @Input()measurementDatas;
   
  constructor(private coreService: CoreService,private apiService: ApiService,) { }

  ngOnInit() {

 
  }

   ngOnChanges(changes) {
     if (changes['measurementDatas'] && this.measurementDatas) {

       console.log("shmaeer test dataaaaaa");
    console.log(this.measurementDatas);
       
 
     }
   }

}
